import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { fieldInputCls } from "@/components/Field";
import { useT } from "@/lib/i18n";

const today = () => new Date().toISOString().slice(0, 10);
const cell = `${fieldInputCls} h-9 text-xs`;

export const maintenanceCost = (rows = []) => rows.reduce((n, m) => n + (Number(m.cost) || 0), 0);

export const MaintenanceList = ({ rows, onChange }) => {
  const { t } = useT();
  const upd = (i, k, v) => onChange(rows.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  const add = () => onChange([{ id: null, date: today(), activity: "", notes: "", cost: null, reset_hours: false }, ...rows]);
  return (
    <div data-testid="maintenance-list" className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-widest text-slate-400">{t("maintenance")} [{rows.length}] · {t("total")} € {maintenanceCost(rows).toFixed(2)}</span>
        <button type="button" data-testid="maintenance-add-btn" onClick={add} className="flex items-center gap-1 px-2.5 py-1 font-mono text-[11px] uppercase border border-[#282D3D] rounded-sm text-slate-300 hover:text-white hover:border-slate-500 transition-colors duration-200">
          <Plus className="w-3.5 h-3.5" /> {t("add_maintenance")}
        </button>
      </div>
      {rows.length === 0 && <p data-testid="maintenance-empty" className="font-mono text-xs text-slate-500 border border-dashed border-[#282D3D] rounded-sm p-4 text-center">{t("no_maintenance")}</p>}
      {rows.map((m, i) => (
        <div key={m.id || `new-${i}`} data-testid={`maintenance-row-${i}`} className="bg-[#090A0F] border border-[#282D3D] rounded-sm p-2.5 space-y-2">
          <div className="grid grid-cols-[minmax(0,1fr)_110px] sm:grid-cols-[160px_minmax(0,1fr)_120px] gap-2">
            <Input data-testid={`maintenance-date-${i}`} type="date" value={m.date || ""} onChange={(e) => upd(i, "date", e.target.value)} className={`${cell} [color-scheme:dark] min-w-0`} />
            <Input data-testid={`maintenance-activity-${i}`} placeholder={t("activity")} value={m.activity || ""} onChange={(e) => upd(i, "activity", e.target.value)} className={`${cell} min-w-0 col-span-2 sm:col-span-1 order-last sm:order-none`} />
            <Input data-testid={`maintenance-cost-${i}`} type="number" min="0" step="0.01" placeholder={t("cost_eur")} value={m.cost ?? ""} onChange={(e) => upd(i, "cost", e.target.value === "" ? null : Number(e.target.value))} className={`${cell} min-w-0`} />
          </div>
          <div className="grid grid-cols-[minmax(0,1fr)_auto_auto] gap-3 items-center">
            <Input data-testid={`maintenance-notes-${i}`} placeholder={t("notes")} value={m.notes || ""} onChange={(e) => upd(i, "notes", e.target.value)} className={`${cell} min-w-0`} />
            <label className="flex items-center gap-2 font-mono text-[10px] uppercase text-slate-400 whitespace-nowrap">
              <Switch data-testid={`maintenance-reset-${i}`} checked={!!m.reset_hours} onCheckedChange={(v) => upd(i, "reset_hours", v)} /> {t("reset_hours")}
            </label>
            <button type="button" data-testid={`maintenance-delete-${i}`} onClick={() => onChange(rows.filter((_, j) => j !== i))} className="p-1.5 text-slate-500 hover:text-[#FF3B30]"><Trash2 className="w-4 h-4" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
